import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";

// Components
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";

import { useTranslation } from "react-i18next";

const MailCheck = ({ setCurrentStep }) => {
	const navigate = useNavigate();
	const findPwForm = useForm();
	const [email, setEmail] = useState("");
	const findPwRequest = useRequest("post", `vc/user/pw/find?id=${email}`);

	const [validateModal, setValidateModal] = useState(false);
	const [validateModalType, setValidateModalType] = useState("");
	const [validateModalMsg, setValidateModalMsg] = useState("");

    const { t } = useTranslation();

	const request = (data) => {
		setEmail(data.email);
	};

	useEffect(() => {
		if (email !== "") {
			findPwRequest.call();
		}
	}, [email]);

	useEffect(() => {
		switch (findPwRequest.state) {
			case API_STATE.done:
				setCurrentStep("mailSend");
				break;
			case API_STATE.error:
				switch (findPwRequest.error.statusCode) {
					case 404:
						setValidateModalType("error");
						setValidateModal(true);
						setValidateModalMsg();
                        setValidateModalMsg(t("pages.auth.FindPwPage.Find.MailCheck.dontExist"))
						break;
					case 500:
						alert(t("pages.auth.FindPwPage.Find.MailCheck.tryAgain"));
						break;
					default:
						break;
				}
				break;
			default:
				break;
		}
	 }, [findPwRequest.state, findPwRequest.error, setCurrentStep]);
	
	return (
		<>
			<div className="phrase-wrap">
				<h3>{t("pages.auth.FindPwPage.Find.MailCheck.forgetPw")}</h3>
				<p>{t("pages.auth.FindPwPage.Find.MailCheck.exisitingAccount")}</p>
				<Form useForm={findPwForm} className="find-pw-form">
					<Input
						name="email"
						type="email"
						placeholder={t("pages.auth.FindPwPage.Find.MailCheck.email")}
						autoComplete="new-password"
						validation={{
							required: t("pages.auth.FindPwPage.Find.MailCheck.enterEmail"),
							pattern: {
								value: /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i,
								message: t("pages.auth.FindPwPage.Find.MailCheck.includingAt"),
							},
						}}
					/>
				</Form>
			</div>
			<div className="btn-wrap">
				<button
					className="btn__solid"
					color="gray"
					onClick={() => navigate('/')}
				>
					{t("pages.auth.FindPwPage.Find.MailCheck.prev")}
				</button>
				<button className="btn__solid" color="primary" onClick={findPwForm.handleSubmit(request)}>
                    {t("pages.auth.FindPwPage.Find.MailCheck.next")}
				</button>
			</div>

			<AlertTemplate
				alertModalState={validateModal}
				setAlertModalToggle={setValidateModal}
				alertType={validateModalType}
			>
				<p className="alert-content">
					<div className="modal-text">{validateModalMsg}</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color={"primary"}
						onClick={() => {
							setValidateModal(false);
							setEmail("");
						}}
					>
						{t("pages.auth.FindPwPage.Find.MailCheck.check")}
					</button>
				</div>
			</AlertTemplate>
		</>
	);
};

export default MailCheck;
